// Other.jsx

import { useEffect, useState } from 'react'
import { useApi } from '../../../../api/api'
import { CopyIcon, EnvelopeIcon } from '@phosphor-icons/react'
import EmailPreviewModal from './PreviewEmail'
import Email from '../../../../assets/source/Email.svg'
import OtherIcon from '../../../../assets/source/Email.svg'
import Scoop from '../../../../assets/appconnect/scoop-logo.png'
import Avatar from '../../../../assets/appconnect/Avatar.svg'
import Gmail from '../../../../assets/appconnect/Gmail.svg'
import Outlook from '../../../../assets/appconnect/Outlook.svg'
import { replace } from 'lodash'
import datasourceDefs from '../../../../api/datasourceConfig'

import {
    ScoopTextField,
    ScoopButton,
    ScoopDialog,
    ScoopText,
    useToast,
} from '../../../../components/ui'
import { useSelector } from 'react-redux'
import styles from './GMail.module.scss'

const bot = datasourceDefs.find((b) => b.name === 'Gmail')

// google api, add redirect to this in code based on the current url
const GMAIL_API_URL = bot.GMAIL_API_URL
const REDIRECT_URI = `${window.location.protocol}//${window.location.host}/gmail`

export const Other = ({ onClose, stepBack, type, basicConfiguration }) => {
    const toast = useToast()
    const { postData } = useApi(bot.BOT_API_URL)

    const [isLoading, setIsLoading] = useState(false)

    const [oauthCode, setOauthCode] = useState('')

    const [userName, setUserName] = useState('') //this is the username returned by the first email scan call, since we don't know what gmail user the user selected

    const [fromSender, setFromSender] = useState('')
    const [emailSubject, setEmailSubject] = useState('')
    const [subjectOnly, setSubjecOnly] = useState(true)
    const [emailsList, setEmailsList] = useState([])
    const [emailPreviewModalOpen, setEmailPreviewModalOpen] = useState(false)
    const [rawEmail, setRawEmail] = useState('')
    const [step, setStep] = useState(0)
    const [emailGenerated, setEmailGenerated] = useState('')
    const [reportName, setReportName] = useState('')
    const [reportDescription, setReportDescription] = useState('')
    const userID = useSelector((state) => state.auth.userID)
    const workspaceID = useSelector((state) => state.auth.workspaceID)
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search)
        const code = queryParams.get('code')

        if (code) {
            const decodedCode = decodeURIComponent(code)
            setOauthCode(decodedCode)
        } else if (queryParams.toString() !== '') {
            console.log('Got back from Google with other parameters:', queryParams.toString())
        }
    }, []) // Empty dependency array ensures this runs once on mount

    useEffect(() => {
        if (step === 1) {
            const emailDomain =
                process.env.REACT_APP_SCOOP_ENV === 'dev'
                    ? '@dev.scoopup.report'
                    : '@scoopup.report'
            setEmailGenerated(`${generateUUID()}${emailDomain}`)
        }
    }, [step])

    const generateUUID = () => {
        return 'xxxxxxxx-xxxx'.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0
            const v = c === 'x' ? r : (r & 0x3) | 0x8
            return v.toString(16)
        })
    }

    const generateInboxName = (emailGenerated) => {
        // Remove the exact substring "@scoopup.report" and "@dev.scoopup.report"
        let withoutDomain = emailGenerated.replace(/@(dev\.)?scoopup\.report/g, '')

        // Replace non-alphanumeric characters, excluding dashes, with an underscore
        let result = withoutDomain.replace(/[^a-zA-Z0-9\-]/g, '_')

        return result
    }

    const scanEmails = async () => {
        const action = {
            action: 'scanEmails',
            emailSubject: emailSubject,
            emailFrom: fromSender,
            max_days_ago: '',
            userName: userName,
            subjectOnly: subjectOnly,
            redirect_uri: REDIRECT_URI,
            oauthCode: oauthCode,
            isDev: process.env.REACT_APP_SCOOP_ENV === 'dev',
        }
        const result = await postData(action)
        if (result?.success)
            toast.success(
                "We're ready to receive your emailed report! We've copied the forward email address to your clipboard"
            )
        return result
    }

    const handleScanEmails = async () => {
        setIsLoading(true)
        try {
            const data = await scanEmails()
            if (data.status === 'success') {
                setEmailsList(data?.emails)
                setUserName(data?.userName)
            } else {
                console.log('error reading emails!')
            }
        } catch (error) {
            console.log(error)
        }
        setIsLoading(false)
    }

    const previewEmail = async (emailID) => {
        const action = {
            action: 'previewEmail',
            userName: userName,
            emailID: emailID,
            isDev: process.env.REACT_APP_SCOOP_ENV === 'dev',
        }
        const result = await postData(action)
        return result
    }

    const handleSetUpInbox = async () => {
        const action = {
            action: 'setupInboxForBot',
            inboxName: generateInboxName(emailGenerated),
            keepOnlyCurrent: basicConfiguration.isMostRecent,
            incremental: basicConfiguration.isIncremental,
            enableMultipleSameDayLoads: basicConfiguration.isMultipleLoads,
            workspaceID: workspaceID,
            service: bot.service,
            label: reportName,
            description: reportDescription,
            userName: userID,
            isDev: process.env.REACT_APP_SCOOP_ENV === 'dev',
        }
        const result = await postData(action)
        toast.success('Thank you. Keep an eye on your email for completion steps.')
        onClose()
    }
    const actions =
        step === 0 ? (
            <div className={styles.actionsContainer}>
                <ScoopButton variant="grey" size="sm" onClick={stepBack}>
                    Back
                </ScoopButton>
                {oauthCode && <ScoopButton onClick={handleScanEmails}>Apply</ScoopButton>}
            </div>
        ) : (
            <>
                <ScoopButton variant="grey" size="sm" onClick={() => setStep(0)}>
                    Back
                </ScoopButton>
                <ScoopButton
                    disabled={!reportName}
                    size="sm"
                    onClick={() => {
                        handleSetUpInbox()
                    }}
                >
                    {' '}
                    I've done this{' '}
                </ScoopButton>
            </>
        )

    return (
        <>
            <EmailPreviewModal
                rawEmail={rawEmail}
                open={emailPreviewModalOpen}
                onClose={() => setEmailPreviewModalOpen(false)}
            />
            <ScoopDialog
                open={true}
                title={'Dataset from your application'}
                actions={actions}
                maxWidth={'800px'}
                onClose={onClose}
            >
                {step === 0 && (
                    <div className={styles.contentContainer}>
                        <div className={styles.contentContainerWide}>
                            {!oauthCode && (
                                <div className={styles.flowContainer}>
                                    <div className={styles.descriptionText}>
                                        Great, now it's time to integrate with your email to allow
                                        Scoop to automatically retrieve future reports.
                                    </div>
                                    <div className={styles.flowDiagram}>
                                        <div className={styles.flowIconBox}>
                                            <img src={OtherIcon} alt={'data source'} />
                                        </div>
                                        <div className={styles.flowDashedLine} />
                                        <img src={Email} alt={'email'} />
                                        <div className={styles.flowDashedLine} />
                                        <div className={styles.flowIconBox}>
                                            <img src={Avatar} alt={'salesforce'} />
                                        </div>
                                        <div className={styles.flowDashedLine} />
                                        <img src={Email} alt={'email'} />
                                        <div className={styles.flowDashedLine} />
                                        <div className={styles.flowIconBoxLarge}>
                                            <img
                                                src={Scoop}
                                                alt={'salesforce'}
                                                className={styles.flowScoopLogo}
                                            />
                                        </div>
                                    </div>
                                    <div className={styles.buttonGroup}>
                                        <ScoopButton
                                            className={styles.fullWidthButton}
                                            variant="grey"
                                            onClick={() => setStep(1)}
                                        >
                                            <img
                                                src={Gmail}
                                                alt="Integrate data source"
                                                className={styles.buttonIcon}
                                            />
                                            {'Gmail'}
                                        </ScoopButton>
                                        <ScoopButton
                                            className={styles.fullWidthButton}
                                            variant="grey"
                                            onClick={() => setStep(1)}
                                            disabled
                                        >
                                            <img
                                                src={Outlook}
                                                alt="Integrate data source"
                                                className={styles.buttonIcon}
                                            />
                                            {'Outlook'}
                                        </ScoopButton>
                                        <ScoopButton
                                            className={styles.fullWidthButton}
                                            variant="grey"
                                            onClick={() => setStep(1)}
                                            disabled
                                        >
                                            <EnvelopeIcon size={20} weight="regular" />
                                            {'Other'}
                                        </ScoopButton>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {step === 1 && (
                    <div className={styles.stepContentInner}>
                        <ScoopText className={styles.headerText}>
                            Forward your application's data reports to this unique Scoop inbox
                            <br />
                            Follow this step by step guide or{' '}
                            <a href="javascript:void(0);" className={styles.linkText}>
                                watch the video
                            </a>
                        </ScoopText>

                        <div className={styles.stepper}>
                            <div className={styles.step}>
                                <div className={styles.stepHeader}>
                                    <div className={styles.stepIcon}>1</div>
                                    <ScoopText className={styles.stepLabel}>
                                        Login into the email account where you expect to receive
                                        reports from your data source
                                    </ScoopText>
                                </div>
                            </div>
                            <div className={styles.step}>
                                <div className={styles.stepHeader}>
                                    <div className={styles.stepIcon}>2</div>
                                    <ScoopText className={styles.stepLabel}>
                                        Forward the email to the following inbox (copy this email
                                        address)
                                    </ScoopText>
                                </div>
                                <div className={styles.stepContent}>
                                    <div className={styles.copyBox}>
                                        {emailGenerated}
                                        <button
                                            className={styles.copyButton}
                                            onClick={() =>
                                                navigator.clipboard.writeText(emailGenerated)
                                            }
                                        >
                                            <CopyIcon size={16} weight="regular" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.step}>
                                <div className={styles.stepHeader}>
                                    <div className={styles.stepIcon}>3</div>
                                    <ScoopTextField
                                        label={'Report description'}
                                        onChange={(event) => {
                                            setReportName(event.target.value)
                                            setReportDescription(event.target.value)
                                        }}
                                        value={reportName}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </ScoopDialog>
        </>
    )
}
